// extracted by mini-css-extract-plugin
export var breadcrumb = "_c-0";
export var breadcrumbArrow = "_c-1";